import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import { WishlistRepositoryImpl } from "../../domain/wishlistRepositoryImpl/WishlistRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const wishlistRepo = WishlistRepositoryImpl.getInstance();

const useAddProductToWishlist = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const mutation = useMutation(
    {
      mutationFn: (variantId: string) => {
        return wishlistRepo.addVariant(variantId, auth, apiUrl);
      },
    },
    queryClient,
  );

  const addProductToWishlist = useCallback(
    (variantId: string, onSuccess: () => void, onError?: (error: unknown) => void) => {
      mutation.mutate(variantId, { onSuccess, onError });
    },
    [mutation],
  );

  return addProductToWishlist;
};

export { useAddProductToWishlist };
